import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxDeeplinkerService } from 'ngx-deeplinker';
import { GlobalAlertService } from '../shared/services/global-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { Context, ContextSelectorService } from 'ngx-global-nav';
import * as moment from 'moment-timezone';
import { Locale } from '../shared/model/locale.model';
import { TemplateService } from '../shared/services/templates.service';
import { ValidatorFunctions } from '../shared/validators/validator.functions';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss', '../shared/shared.styles.scss'],
})
export class CreateComponent {
  SUCCESS = 'Created Successfully';
  BAD_REQUEST = 'Oops, There was a problem with your request';
  NOT_CREATED = 'Oops, There was a problem creating your template';
  REQUIRED = 'required';

  isSubmitting = false;

  templateForm: FormGroup = new FormGroup({
    displayLabel: new FormControl('', Validators.required),
    supportedLocales: new FormControl([new Locale()], Validators.required),
    defaultLocale: new FormControl('en_US', Validators.required),
    timezone: new FormControl('America/New_York', Validators.required)
  });
  readonly APPPREFIX = 'prt';
  readonly mode = 'create';

  constructor(
    private ngxDeeplinkerService: NgxDeeplinkerService,
    private router: Router,
    private messageService: GlobalAlertService,
    private templateService: TemplateService,
    private translateService: TranslateService,
  ) {
    this.templateService.selectedTemplateId$.next('');
    this.translateService.get('template.notification.created_successfully').subscribe((result: string) => {
      this.SUCCESS = result;
      this.BAD_REQUEST = this.translateService.instant('template.notification.bad_request');
      this.NOT_CREATED = this.translateService.instant('template.notification.not_created');
      this.REQUIRED = this.translateService.instant('template.validation.required');
    });
  }

  handleCancel() {
    this.ngxDeeplinkerService.returnHandler({ appPrefix: this.APPPREFIX });
    this.router.navigate(['/']);
  }

  async handleSubmit() {
    if (!this.templateForm.valid) {
      this.messageService.setError(this.REQUIRED);
    } else {
      try {
        this.isSubmitting = true;
        const response = await this.templateService.createTemplate({ ...this.templateForm.getRawValue() });
        this.ngxDeeplinkerService.returnHandler({ appPrefix: this.APPPREFIX, callbackValue: response.id });
        this.messageService.setSuccess(this.SUCCESS);
        setTimeout(() => {
          this.templateService.refetchTemplates();
          // this.router.navigate([`details/${response.id}/view`], {});
          this.router.navigate([`details/123/view`], {});
        }, 2000);
      } catch (e) {
        console.log(e);
        if (e) {
          const errorMessage = e.error.message;
          if (errorMessage === 'ERR_BAD_REQUEST') {
            this.messageService.setError(this.BAD_REQUEST);
          } else {
            this.messageService.setError(this.NOT_CREATED);
          }
        }
      }
      this.isSubmitting = false;
    }
  }
}
